import HelpRequestModal from './HelpRequestModal';
import MobileHelpRequestModal from './MobileHelpRequestModal';
import { isMobile } from '@util/index';
import Button, { ButtonProps } from '@ui/Button';

import { MessageIcon } from '@c/icons';
import { useState } from 'react';
import { useAuth } from 'context/AuthContext';
import { useRouter } from 'next/navigation';
import { cx } from 'class-variance-authority';

export default function HelpRequestButton({
  order_id,
  variant,
  className,
}: {
  order_id: string;
  variant: 'buyer' | 'seller';
  className?: string;
}) {
  const { user } = useAuth();
  const router = useRouter();
  const [helpRequestOpen, setHelpRequestOpen] = useState(false);

  return (
    <>
      <Button
        type="outline"
        className={cx('h-[4rem] py-0', className)}
        text="Help With Order"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          user?.isAnonymous
            ? router.push('/verify-phone')
            : setHelpRequestOpen(true);
        }}
        width="fluid"
      />
      {isMobile() ? (
        <MobileHelpRequestModal
          show={helpRequestOpen}
          dismiss={() => setHelpRequestOpen(false)}
          order_id={order_id}
          variant={variant}
        />
      ) : (
        <HelpRequestModal
          isOpen={helpRequestOpen}
          dismiss={() => setHelpRequestOpen(false)}
          order_id={order_id}
          variant={variant}
        />
      )}
    </>
  );
}
